import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class ToId extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: string): ToId {
    return new ToId(value);
  }

  /** 文字列にする */
  override toString() {
    return this.value;
  }
}
